(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-gift-box-upsell-assets"] && !Shopify.designMode) return;
  try {
    if (!window.misyCartGiftBoxUpsellBound) {
    window.misyCartGiftBoxUpsellBound = true;

    document.addEventListener("click", async (event) => {
      const button = event.target.closest("[data-cart-gift-box-add]");

      if (!button || button.getAttribute("aria-busy") === "true") {
        return;
      }

      event.preventDefault();

      const variantId = Number.parseInt(button.getAttribute("data-gift-box-variant-id"), 10);
      const quantity = Number.parseInt(button.getAttribute("data-gift-box-quantity") || "1", 10);
      const propertyName = button.getAttribute("data-gift-box-property-name");
      const propertyValue = button.getAttribute("data-gift-box-property-value");

      if (!Number.isFinite(variantId)) {
        return;
      }

      button.setAttribute("aria-busy", "true");
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));

      try {
        const sectionsToBundle = [];
        document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));

        const giftBoxItem = {
          id: variantId,
          quantity: Number.isFinite(quantity) && quantity > 0 ? quantity : 1
        };

        if (propertyName && propertyValue) {
          giftBoxItem.properties = {
            [propertyName]: propertyValue
          };
        }

        const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest"
          },
          body: JSON.stringify({
            items: [giftBoxItem],
            sections: sectionsToBundle.join(","),
            sections_url: `${Shopify.routes.root}cart`
          })
        });

        const responseJson = await response.json();

        if (!response.ok) {
          throw new Error(responseJson.description || "Gift box add failed");
        }

        const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
        cartContent.sections = responseJson.sections;

        document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
          bubbles: true,
          detail: {
            baseEvent: "variant:add",
            onSuccessDo: "force_open_drawer",
            cart: cartContent
          }
        }));
      } catch (error) {
        document.dispatchEvent(new CustomEvent("cart:refresh"));
      } finally {
        button.removeAttribute("aria-busy");
        document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lovely-necklace-visual-picker"] && !Shopify.designMode) return;
  try {
    if (!window.misyLovelyNecklacePickerBound) {
    window.misyLovelyNecklacePickerBound = true;

    const setCurrentCard = (picker, optionValue) => {
      picker.querySelectorAll("[data-lovely-option-value]").forEach((item) => {
        item.setAttribute("aria-current", item.getAttribute("data-lovely-option-value") === optionValue ? "true" : "false");
      });
    };

    const scrollToMedia = (picker, mediaId) => {
      const carouselId = picker.getAttribute("data-carousel-id");
      const carousel = carouselId ? document.getElementById(carouselId) : picker.closest("product-gallery")?.querySelector(".product-gallery__carousel");
      const media = carousel?.querySelector(`[data-media-id="${mediaId}"]`);

      if (media) {
        media.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
      }
    };

    document.addEventListener("click", (event) => {
      const button = event.target.closest("[data-lovely-option-value]");

      if (!button) {
        return;
      }

      const picker = button.closest("[data-lovely-picker]");
      const formId = picker?.getAttribute("data-form-id");
      const optionValue = button.getAttribute("data-lovely-option-value");
      const mediaId = button.getAttribute("data-lovely-media-id");
      const input = formId ? document.querySelector(`input[form="${CSS.escape(formId)}"][data-option-position="1"][value="${CSS.escape(optionValue)}"]`) : null;

      if (input && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }

      if (picker) {
        setCurrentCard(picker, optionValue);
      }

      if (picker && mediaId) {
        scrollToMedia(picker, mediaId);
      }
    });

    document.addEventListener("change", (event) => {
      const input = event.target;

      if (!input.matches('input[data-option-position="1"][form]')) {
        return;
      }

      document.querySelectorAll(`[data-lovely-picker][data-form-id="${CSS.escape(input.getAttribute("form"))}"]`).forEach((picker) => {
        setCurrentCard(picker, input.value);
      });
    });
  }
  } catch(e) { console.error(e); }
})();

})();
